import { Routes } from '@/src/common/enums/routes'
import { VerifyPhoneOTP } from '@/src/common/components/VerifyPhoneOTP'
import { useSardine } from '@/src/services/Sardine'
import { useEffect } from 'react'

export function VerifyPhoneOTPCardApplication() {
  const { updateOptions } = useSardine()

  useEffect(() => {
    void updateOptions({ flow: 'application-verify-phone-otp' })
  }, [updateOptions])

  return (
    <VerifyPhoneOTP
      backButtonHref={Routes.OnboardingVerifyOtp.route}
      postVerifyPhoneNumberRouterPush={Routes.FindYourHome.route}
    />
  )
}
